import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/newhome/title.png'
import _imports_1 from '../../../assets/image/newhome/2/imgback.png'
import _imports_2 from '../../../assets/image/newhome/2/qudong1.png'
import _imports_3 from '../../../assets/image/newhome/2/qudong2.png'
import _imports_4 from '../../../assets/image/newhome/2/qudong4.png'
import _imports_5 from '../../../assets/image/newhome/2/qudong3.png'
import _imports_6 from '../../../assets/image/newhome/2/shijue1.png'
import _imports_7 from '../../../assets/image/newhome/2/shijue2.png'
import _imports_8 from '../../../assets/image/newhome/2/sifu1.png'
import _imports_9 from '../../../assets/image/newhome/2/sifu2.png'
import _imports_10 from '../../../assets/image/newhome/2/jiansuji1.png'
import _imports_11 from '../../../assets/image/newhome/2/jiansuji2.png'
import _imports_12 from '../../../assets/image/newhome/2/jiansuji4.png'
import _imports_13 from '../../../assets/image/newhome/2/jiansuji3.png'
import _imports_14 from '../../../assets/image/newhome/2/zhenkong1.png'
import _imports_15 from '../../../assets/image/newhome/2/zhenkong2.png'
import _imports_16 from '../../../assets/image/newhome/2/RVbai.png'
import _imports_17 from '../../../assets/image/newhome/2/RVZi.png'
import _imports_18 from '../../../assets/image/newhome/2/xiezuo1.png'
import _imports_19 from '../../../assets/image/newhome/2/xiezuo2.png'
import _imports_20 from '../../../assets/image/newhome/2/xiezuo4.png'
import _imports_21 from '../../../assets/image/newhome/2/xiezuo3.png'
import _imports_22 from '../../../assets/image/newhome/2/BinglianBai.png'
import _imports_23 from '../../../assets/image/newhome/2/BinglianDizuoBai.png'
import _imports_24 from '../../../assets/image/newhome/2/BinglianZi.png'
import _imports_25 from '../../../assets/image/newhome/2/BinglianDizuoZi.png'
import _imports_26 from '../../../assets/image/newhome/2/kongzhi1.png'
import _imports_27 from '../../../assets/image/newhome/2/kongzhi2.png'
import _imports_28 from '../../../assets/image/newhome/2/kongzhi4.png'
import _imports_29 from '../../../assets/image/newhome/2/kongzhi3.png'
import _imports_30 from '../../../assets/image/newhome/2/chaunlian1.png'
import _imports_31 from '../../../assets/image/newhome/2/chaunlian2.png'
import _imports_32 from '../../../assets/image/newhome/2/chaunlian4.png'
import _imports_33 from '../../../assets/image/newhome/2/chaunlian3.png'
import _imports_34 from '../../../assets/image/newhome/2/man.png'
import _imports_35 from '../../../assets/image/newhome/2/blueLight.png'
import _imports_36 from '../../../assets/image/newhome/2/hengxian.png'
import _imports_37 from '../../../assets/image/newhome/2/sifuxian.png'
import _imports_38 from '../../../assets/image/newhome/2/shijuexian.png'
import _imports_39 from '../../../assets/image/newhome/2/jiansujixian.png'
import _imports_40 from '../../../assets/image/newhome/2/chuanlianxian.png'
import _imports_41 from '../../../assets/image/newhome/jiantou.png'


const _withScopeId = n => (_pushScopeId("data-v-084ef739"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scheme" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-084ef739><img src=\"" + _imports_0 + "\" alt=\"\" data-v-084ef739><div class=\"text\" data-v-084ef739>工业自动化设备供应链</div><img src=\"" + _imports_0 + "\" alt=\"\" data-v-084ef739></div><div class=\"title1\" data-v-084ef739>海量精品汇聚， 一键筛选渠道直达</div>", 2)
const _hoisted_4 = { class: "scheme-img container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "imgback"
}, null, -1))
const _hoisted_6 = {
  src: _imports_4,
  alt: "",
  class: "qudong"
}
const _hoisted_7 = {
  src: _imports_5,
  alt: "",
  class: "qudong1"
}
const _hoisted_8 = {
  src: _imports_7,
  alt: "",
  class: "shijue"
}
const _hoisted_9 = {
  src: _imports_9,
  alt: "",
  class: "sifu"
}
const _hoisted_10 = {
  src: _imports_11,
  alt: "",
  class: "jiansujidi dibu"
}
const _hoisted_11 = {
  src: _imports_12,
  alt: "",
  class: "jiansuji"
}
const _hoisted_12 = {
  src: _imports_13,
  alt: "",
  class: "jiansujidi dibu"
}
const _hoisted_13 = {
  src: _imports_15,
  alt: "",
  class: "zhenkong"
}
const _hoisted_14 = {
  src: _imports_11,
  alt: "",
  class: "rvdi dibu"
}
const _hoisted_15 = {
  src: _imports_13,
  alt: "",
  class: "rvdi dibu"
}
const _hoisted_16 = {
  src: _imports_17,
  alt: "",
  class: "rv"
}
const _hoisted_17 = {
  src: _imports_19,
  alt: "",
  class: "xiezuodi"
}
const _hoisted_18 = {
  src: _imports_20,
  alt: "",
  class: "xiezuo"
}
const _hoisted_19 = {
  src: _imports_21,
  alt: "",
  class: "xiezuodi"
}
const _hoisted_20 = {
  src: _imports_23,
  alt: "",
  class: "bingliandi"
}
const _hoisted_21 = {
  src: _imports_24,
  alt: "",
  class: "binglian"
}
const _hoisted_22 = {
  src: _imports_25,
  alt: "",
  class: "bingliandi"
}
const _hoisted_23 = {
  src: _imports_27,
  alt: "",
  class: "kongzhidi"
}
const _hoisted_24 = {
  src: _imports_28,
  alt: "",
  class: "kongzhi"
}
const _hoisted_25 = {
  src: _imports_29,
  alt: "",
  class: "kongzhidi"
}
const _hoisted_26 = {
  src: _imports_31,
  alt: "",
  class: "chuanliandi"
}
const _hoisted_27 = {
  src: _imports_32,
  alt: "",
  class: "chuanlian"
}
const _hoisted_28 = {
  src: _imports_33,
  alt: "",
  class: "chuanliandi"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_34,
  alt: "",
  class: "man"
}, null, -1))
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_36,
  alt: "",
  class: "hengxian"
}, null, -1))
const _hoisted_32 = {
  key: 0,
  class: "indicator"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sifu" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_37,
    alt: "",
    class: "jiantou"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "伺服驱动器")
], -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "indicator"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shijuezhishi" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_38,
    alt: "",
    class: "jiantou"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "机器视觉系统")
], -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 2,
  class: "indicator"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xingxingzhishi" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_38,
    alt: "",
    class: "jiantou"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "行星减速机")
], -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  key: 3,
  class: "indicator"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "RVzhishi" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_39,
    alt: "",
    class: "jiantou"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "RV减速机")
], -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 4,
  class: "indicator"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chuanlianzhishi" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_40,
    alt: "",
    class: "jiantou"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "串联机器人")
], -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "good-title container" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "p" }
const _hoisted_50 = {
  key: 0,
  src: _imports_41,
  alt: "",
  class: "jiantou"
}
const _hoisted_51 = { class: "good-list container" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "pic" }
const _hoisted_54 = ["src"]
const _hoisted_55 = { class: "txt" }
const _hoisted_56 = { class: "title-two nowrap" }
const _hoisted_57 = { class: "attr nowrap" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "more",
  href: "https://www.movibot-art.com/class/index/1",
  target: "_blank"
}, " 查看更多 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createElementVNode("img", {
        src: _imports_2,
        alt: "",
        class: "qudong",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.active(3)))
      }, null, 512), [
        [_vShow, _ctx.isActive != 3]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _imports_3,
        alt: "",
        class: "qudong1",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.active(3)))
      }, null, 512), [
        [_vShow, _ctx.isActive != 3]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
        [_vShow, _ctx.isActive == 3]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
        [_vShow, _ctx.isActive == 3 || _ctx.isActive == 9]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _imports_6,
        alt: "",
        class: "shijue",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.active(9)))
      }, null, 512), [
        [_vShow, _ctx.isActive != 9]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
        [_vShow, _ctx.isActive == 9]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _imports_8,
        alt: "",
        class: "sifu",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.active(2)))
      }, null, 512), [
        [_vShow, _ctx.isActive != 2]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
        [_vShow, _ctx.isActive == 2]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _imports_10,
        alt: "",
        class: "jiansuji",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.active(1)))
      }, null, 512), [
        [_vShow, _ctx.isActive != 1]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
        [_vShow, _ctx.isActive != 1]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [
        [_vShow, _ctx.isActive == 1]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [
        [_vShow, _ctx.isActive == 1]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _imports_14,
        alt: "",
        class: "zhenkong",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.active(7)))
      }, null, 512), [
        [_vShow, _ctx.isActive != 7]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [
        [_vShow, _ctx.isActive == 7]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _imports_16,
        alt: "",
        class: "rv",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.active(0)))
      }, null, 512), [
        [_vShow, _ctx.isActive != 0]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [
        [_vShow, _ctx.isActive != 0]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_15, null, 512), [
        [_vShow, _ctx.isActive == 0]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_16, null, 512), [
        [_vShow, _ctx.isActive == 0]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _imports_18,
        alt: "",
        class: "xiezuo",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.active(6)))
      }, null, 512), [
        [_vShow, _ctx.isActive != 6]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_17, null, 512), [
        [_vShow, _ctx.isActive != 6]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_18, null, 512), [
        [_vShow, _ctx.isActive == 6]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_19, null, 512), [
        [_vShow, _ctx.isActive == 6]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _imports_22,
        alt: "",
        class: "binglian",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.active(4)))
      }, null, 512), [
        [_vShow, _ctx.isActive != 4]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_20, null, 512), [
        [_vShow, _ctx.isActive != 4]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_21, null, 512), [
        [_vShow, _ctx.isActive == 4]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_22, null, 512), [
        [_vShow, _ctx.isActive == 4]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _imports_26,
        alt: "",
        class: "kongzhi",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.active(8)))
      }, null, 512), [
        [_vShow, _ctx.isActive != 8]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_23, null, 512), [
        [_vShow, _ctx.isActive != 8]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_24, null, 512), [
        [_vShow, _ctx.isActive == 8]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_25, null, 512), [
        [_vShow, _ctx.isActive == 8]
      ]),
      _withDirectives(_createElementVNode("img", {
        src: _imports_30,
        alt: "",
        class: "chuanlian",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.active(5)))
      }, null, 512), [
        [_vShow, _ctx.isActive != 5]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_26, null, 512), [
        [_vShow, _ctx.isActive != 5]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_27, null, 512), [
        [_vShow, _ctx.isActive == 5]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_28, null, 512), [
        [_vShow, _ctx.isActive == 5]
      ]),
      _hoisted_29,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lightLocation, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("img", {
            src: _imports_35,
            alt: "",
            class: "light",
            onClick: ($event: any) => (_ctx.active(index)),
            style: _normalizeStyle({ left: item.left, top: item.top })
          }, null, 12, _hoisted_30)
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleLocation, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "indicator"
        }, [
          (_ctx.isActive == index && item.id && item.id == index)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: _normalizeStyle({ position: 'absolute', left: item.left, top: item.top })
              }, [
                _hoisted_31,
                _createElementVNode("p", null, _toDisplayString(item.name), 1)
              ], 4))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (_ctx.isActive == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
        : _createCommentVNode("", true),
      (_ctx.isActive == 9)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
        : _createCommentVNode("", true),
      (_ctx.isActive == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
        : _createCommentVNode("", true),
      (_ctx.isActive == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
        : _createCommentVNode("", true),
      (_ctx.isActive == 5)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_47, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.title, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["title-item", { 'active': _ctx.isActive == index }]),
          key: index,
          onClick: ($event: any) => (_ctx.active(index))
        }, [
          _createElementVNode("p", _hoisted_49, _toDisplayString(item.name), 1),
          (index == _ctx.isActive)
            ? (_openBlock(), _createElementBlock("img", _hoisted_50))
            : _createCommentVNode("", true)
        ], 10, _hoisted_48))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_51, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodslit.datas.data, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "goods-info",
          key: index,
          onClick: ($event: any) => (_ctx.goto(item.id))
        }, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("img", {
              class: "pic-img",
              src: item.pic
            }, null, 8, _hoisted_54)
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_57, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.parameter, (items, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: index,
                  class: "nowrap"
                }, _toDisplayString(index) + ": " + _toDisplayString(items), 1))
              }), 128))
            ])
          ])
        ], 8, _hoisted_52))
      }), 128)),
      _hoisted_58
    ])
  ]))
}